import { useNavigate } from 'react-router-dom';

import { useCreateNotificationMutation } from '../api';

import type { MessageCreateModel } from '@/features/Shared';
import type { SubmitHandler } from 'react-hook-form';

import { CreateFormLayout } from '@/features/Shared/forms';

export const CreateNotificationLayout = () => {
	const navigate = useNavigate();
	const [create] = useCreateNotificationMutation();

	const handleSubmit: SubmitHandler<MessageCreateModel> = async (data) => {
		try {
			await create(data).unwrap();
			navigate('/notifications');
		} catch {
			// Handle error (e.g., show a notification)
		}
	};

	return (
		<CreateFormLayout
			title="Create Notification"
			buttonText="Send Notification"
			value={{
				content: {
					title: {
						text: '',
					},
					body: {
						text: '',
					},
				},
				recipientGroups: [],
			}}
			onSubmit={handleSubmit}
		/>
	);
};
